import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Émet un pageview au montage + à chaque changement de route (SPA).
// N'envoie PAS de pageview sur les routes internes admin/agent (visites internes bruyantes).
const _EXCLUDE_RX = /^\/(admin|agent|api|verify|sign-contract|restaurateur\/dashboard)/i;

export default function PageviewTracker() {
  const location = useLocation();
  const lastSent = useRef(null);

  useEffect(() => {
    const path = location.pathname || "/";
    if (_EXCLUDE_RX.test(path)) return;
    // Dédup : évite double-envoi sur re-render dans la même route.
    if (lastSent.current === path) return;
    lastSent.current = path;

    const body = JSON.stringify({
      path,
      ref: document.referrer || "",
      lang: navigator.language || "",
      screen: `${window.screen?.width || 0}x${window.screen?.height || 0}`,
      is_pwa: window.matchMedia("(display-mode: standalone)").matches,
    });
    // sendBeacon = envoi non-bloquant, survit à la navigation
    try {
      const blob = new Blob([body], { type: "application/json" });
      if (navigator.sendBeacon) {
        navigator.sendBeacon(`${API}/analytics/pageview`, blob);
        return;
      }
    } catch { /* fallback */ }
    fetch(`${API}/analytics/pageview`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body,
      keepalive: true,
    }).catch(() => { /* ignore */ });
  }, [location.pathname]);

  return null;
}
